export const requests = {
  auth: {
    getOtp: 'auth/get-otp',
    loginOrRegister: 'auth/login-or-register-by-otp',
    loginUserPass: 'auth/login',
    resetPass: 'auth/reset-password',
    forgetPassword: 'auth/forgot-password',
    checkOtp: (username, code) => `auth/check-otp-code/${username}/${code}`,
    logout: 'auth/logout',
    getUser: 'auth/get-user',
  },
  user: {
    viewProfile: 'user/profile',
    editProfile: 'user/profile',
    bankAccount: 'user/bank-account',
    addBankAccount: 'user/bank-account',
    editBankAccount: (bankAccountId) => `user/bank-account/${bankAccountId}`,
    deleteBankAccount: (bankAccountId) => `user/bank-account/${bankAccountId}`,
    getCallNumber: 'user/call-number',
    deleteCallNumber: (callNumberId) => `user/call-number/${callNumberId}`,
    createCallNumber: 'user/call-number',
    editCallNumber: (callNumberId) => `user/call-number/${callNumberId}`,
    callNumber: 'user/call-number',
  },
  global: {
    geocoding: {
      reverse: 'geocoding-reverse',
    },
  },
  management: {
    user: {
      getAll: 'user',
      increaseWallet: (userId) => `user/${userId}/increase-credit`,
      decreaseWallet: (userId) => `user/${userId}/decrease-credit`,
      block: (userId) => `user/${userId}/block`,
      unBlock: (userId) => `user/${userId}/unblock`,
      transactionWallet: (userId) => `user/${userId}/show-transactions-of-wallet`,
      assignRole: 'user/assign-role',
      showRole: (userId) => `user/${userId}`,
      revokeRole: 'user/revoke-role',
      syncCourierSub: (courierId) => `courier/${courierId}/add-user-as-employee`,
      deleteUserEmployee: (courierId) => `courier/${courierId}/delete-user-as-employee`,
      userSearch: (userName) => `user/${userName}/search`,
      markBnplCandidates: 'user/mark-bnpl-candidates',
      deleteBnplCandidates: 'user/delete-bnpl-candidates',
    },
    discountCode: {
      getAll: 'discountcode',
      create: 'discountcode',
      delete: (discountCodeId) => `discountcode/${discountCodeId}`,
      show: (discountCodeId) => `discountcode/${discountCodeId}`,
    },
    qazvinProPlan: {
      getAll: 'qazvin-pro-plan',
      create: 'qazvin-pro-plan',
      show: (planUuid) => `qazvin-pro-plan/${planUuid}`,
      edit: (planUuid) => `qazvin-pro-plan/${planUuid}`,
      delete: (planUuid) => `qazvin-pro-plan/${planUuid}`,
    },
    qazvinProBenefitPool: {
      getAll: 'qazvin-pro-benefit-pool',
      create: 'qazvin-pro-benefit-pool',
      show: (poolId) => `qazvin-pro-benefit-pool/${poolId}`,
      edit: (poolId) => `qazvin-pro-benefit-pool/${poolId}`,
      delete: (poolId) => `qazvin-pro-benefit-pool/${poolId}`,
      // codes
      getCodes: (poolId) => `qazvin-pro-benefit-pool/${poolId}/codes`,
      addCodes: (poolId) => `qazvin-pro-benefit-pool/${poolId}/codes`,
      editCode: (poolId, codeId) => `qazvin-pro-benefit-pool/${poolId}/codes/${codeId}`,
      deleteCode: (poolId, codeId) => `qazvin-pro-benefit-pool/${poolId}/codes/${codeId}`,
      deleteAllCodes: (poolId) => `qazvin-pro-benefit-pool/${poolId}/codes`,
      // claims
      getClaims: (poolId) => `qazvin-pro-benefit-pool/${poolId}/claims`,
      exportClaims: (poolId) => `qazvin-pro-benefit-pool/${poolId}/claims/export`,
    },
    advertisement: {
      getAll: 'advertisement',
      getOne: (advertisementId) => `advertisement/${advertisementId}`,
      create: 'advertisement',
      edit: (advertisementId) => `advertisement/${advertisementId}`,
      delete: (advertisementId) => `advertisement/${advertisementId}`,
    },
    geofence: {
      getAll: 'geofence',
      getById: (geofenceId) => `geofence/${geofenceId}`,
      create: 'geofence',
      edit: (geofenceId) => `geofence/${geofenceId}`,
      delete: (geofenceId) => `geofence/${geofenceId}`,
      isActive: (geofenceId) => `geofence/${geofenceId}/update-active-status`,
    },
    invoice: {
      getAll: 'invoice',
      refund: (invoiceId) => `invoice/${invoiceId}/refund`,
      unitScore: (invoiceId) => `invoice/${invoiceId}/set-extra-rank`,
      cancel: (invoiceId) => `invoice/${invoiceId}/cancel`,
      accept: (invoiceId) => `invoice/${invoiceId}/accept`,
      listOfRefunds: (invoiceId) => `invoice/${invoiceId}/list-of-refunds`,
      listOfSmsHistory: (invoiceId) => `invoice/${invoiceId}/history-of-invoice-sms`,
      changeCourier: (invoiceId) => `invoice/${invoiceId}/change-courier-type-to-express`,
      invoiceTransaction: (invoiceId) => `invoice/${invoiceId}/manual-transaction`,
      markedasCorrection: (ticketUUID) => `invoice/${ticketUUID}/marked-as-correction-invoice-resolved`,

      orderList: (invoiceId) => `invoice/${invoiceId}`,
      sendSms: (invoiceId) => `invoice/${invoiceId}/send-on-demand-sms`,
      reSendSms: (invoiceId) => `invoice/${invoiceId}/send-on-demand-sms`,
      count: 'invoice/pending-tickets/get-count',
      requestCourier: (invoiceId, courierId) => `invoice/${invoiceId}/${courierId}/request-courier`,
      invoiceCourier: (invoiceId) => `invoice/${invoiceId}/set-send-at`,
      discountCode:(invoiceId) => `invoice/${invoiceId}/gift-discountcode`,
    },
    credit: {
      getAll: 'bnpl-agreement',
      action: (crediteId) => `bnpl-payment-tracking/${crediteId}`,
      delete: (crediteId) => `bnpl-payment-tracking/${crediteId}`,
      listOfTrackings: (crediteId) => `bnpl-payment-tracking/${crediteId}/list-of-trackings`,
    },
    delay_invoice: {
      getAll: 'delay-invoice',
      reasonDelayInvoice: (invoiceId) => `invoice/${invoiceId}/response-delay-invoice`,
    },
    shortage_invoice: {
      getAll: 'shortage-invoice',
      markedhortageInvoiceResolved: (invoiceId) => `invoice/${invoiceId}/marked-as-shortage-invoice-resolved`,
    },
    correction_invoice: {
      getAll: 'correction-invoice',
      markedCorrectionInvoiceResolved: (invoiceId) => `invoice/${invoiceId}/marked-as-correction-invoice-resolved`,
    },
    productCategory: {
      getAll: 'product-category',
      getById: (productCategoryId) => `product-category/${productCategoryId}`,
      create: 'product-category',
      edit: (productCategoryId) => `product-category/${productCategoryId}`,
      delete: (productCategoryId) => `product-category/${productCategoryId}`,
    },
    setting: {
      getAll: 'app-setting',
      cashbackSegments: 'app-setting/cashback-segments',
      getAllPricePerKm: 'courier',
      getAllPricePerKmPrice: 'courier/price/get',
      createPricePerKm: 'courier',
      createPricePerKmPrice: 'app-setting/set-courier-price',
      minPriceCourierExpress: 'app-setting/set-min-courier-price',

      getNumberOperator: 'app-setting',
      getOperatorNumber: 'app-setting/get-operator-number',
      editNumberOperator: 'app-setting',
      editOperatorNumber: 'app-setting/set-operator-number',
      editLineNumberSendSms: 'app-setting',
      editLineNumber: 'app-setting/set-sms-line-number',
      getAllLineNumber: 'app-setting/get-line-number',
      getNoticeOperatorNumber: 'app-setting/get-notice-operator-number',
      setNoticeOperatorNumber: 'app-setting/set-notice-supporter-number',
      getConfig: 'app-setting/get-config',
      getOperatos: 'user/operators/get',
      SetSupporterNumber: 'app-setting/set-supporter-number',
      setActivePayment: 'app-setting/set-active-payment-methods',
      setAppName: 'app-setting/set-app-name',
      setAppSupporterNumber: 'app-setting/set-app-supporting-number',
      setInvoiceRepaymentTimeout: 'app-setting/set-invoice-repayment-timeout',
      app_discountcode_module_status: 'app-setting/set-app-discountcode-module-status',
    },
    role: {
      getAll: 'role',
      getAllPermission: 'role/suggestion-permissions/get',
      getShopPermission: (shopId) => `shop/${shopId}/get-suggestion`,
      create: 'role',
      delete: (roleId) => `role/${roleId}`,
      edit: (roleId) => `role/${roleId}`,
      showRole: (roleId) => `role/${roleId}`,
      getALlShopSubRoles: (shopId) => `shop/${shopId}/role`,
      syncShopSubRoles: (shopId) => `shop/${shopId}/sync-roles`,
      addShopRole: (shopId) => `shop/${shopId}/role`,
      editShopRole: (shopId, roleId) => `shop/${shopId}/role/${roleId}`,
      showShopRole: (shopId, roleId) => `shop/${shopId}/role/${roleId}`,
      deleteShopRole: (shopId, roleId) => `shop/${shopId}/role/${roleId}`,
      getAllShopRoles: (shopId) => `shop/${shopId}/role`,
    },

    settlement: {
      getAll: 'settlement',
      edit: (settlementId) => `settlement/${settlementId}`,
      show: (settlementId) => `settlement/${settlementId}`,
      send_sms: (settlementId) => `settlement/${settlementId}/send-sms`,
      change_to_settled: (settlementId) => `settlement/${settlementId}/change-to-settled`,
      courierSearch: 'courier/lite/get',
      settlementCouriers: 'settlement/create-settlement-for-couriers',
      settlementShops: 'settlement/create-settlement-for-shops',
      delete: (settlementId) => `settlement/${settlementId}/destroy-settlement-period`,
      deleteDeleteSettelemnt: (settlementDetailId) => `settlement/${settlementDetailId}`,
      change_detail_settled: (settlementDetailId) => `settlement/${settlementDetailId}/change-settlement-to-settled`,
    },
    settlement_accumulative: {
      getAll: 'settlement-accumulative',
      edit: (settlementId) => `settlement-accumulative/${settlementId}`,
      show: (settlementId) => `settlement-accumulative/${settlementId}`,
      send_sms: (settlementId) => `settlement-accumulative/${settlementId}/send-sms`,
      change_to_settled: (settlementId) => `settlement-accumulative/${settlementId}/change-to-settled`,
      courierSearch: 'courier/lite/get',
      settlementCouriers: 'settlement-accumulative/create-settlement-for-couriers',
      settlementShops: 'settlement-accumulative/create-settlement-for-shops',
      delete: (settlementId) => `settlement-accumulative/${settlementId}/destroy-settlement-period`,
      deleteDeleteSettelemnt: (settlementDetailId) => `settlement-accumulative/${settlementDetailId}`,
      change_detail_settled: (settlementDetailId) =>
        `settlement-accumulative/${settlementDetailId}/change-settlement-to-settled`,
    },
    transaction: {
      getAll: 'transaction',
      create: 'transactions/manual-transaction',
      search: (shopName) => `shop/${shopName}/search`,
      courierSearch: (courierName) => `courier/${courierName}/search`,
      taxReport: 'transactions/tax-report',
    },
    walletPayment: {
      getAll: 'wallet-payment',
      refund: (walletId) => `wallet-payment/${walletId}/refund`,
    },

    shopSettings: {
      editCategory: 'shop-settings/',
      editLogo: (shopId) => `shop-settings/${shopId}/logo`,
      editHeader: (shopId) => `shop-settings/${shopId}/header`,
      syncCallNumbers: (shopId) => `shop-settings/${shopId}/call-numbers`,
      syncShopCategories: (shopId) => `shop-settings/${shopId}/shop-categories`,
      syncShopMealTags: (shopId) => `shop-settings/${shopId}/meal-tags`,
      paymentMethods: 'shop-settings/payment-methods',
      noticeCallNumbers: (shopId) => `shop-settings/${shopId}/notice-call-numbers`,
      usersCallNumbers: (shopId) => `shop-settings/${shopId}/users-call-numbers`,
      syncNoticeCallNumbers: (shopId) => `shop-settings/${shopId}/notice-call-numbers`,
      getCheckoutCallNumbers: (shopId) => `shop-settings/${shopId}/checkout-call-numbers`,
      syncCheckoutCallNumbers: (shopId) => `shop-settings/${shopId}/checkout-call-numbers`,
      syncShopSettlementCategories: (shopId) => `shop-settings/${shopId}/shop-settlement-categories`,
    },
    shopCategory: {
      getAll: 'shop-category',
      edit: (categoryId) => `shop-category/${categoryId}`,
      delete: (categoryId) => `shop-category/${categoryId}`,
      create: 'shop-category',
    },
    shopCategoryHighlight: {
      getAll: 'highlight-product-category',
      edit: (categoryId) => `highlight-product-category/${categoryId}`,
      delete: (categoryId) => `highlight-product-category/${categoryId}`,
      create: 'highlight-product-category',
    },
    shopWage: {
      setShopWage: 'wage/shop',
    },
    shop: {
      getAll: 'shop',
      create: 'shop',
      getById: (shopId) => `shop/${shopId}`,
      edit: (shopId) => `shop/${shopId}`,
      getShopGeofence: (shopId) => `shop/${shopId}/geofence`,
      deleteShopGeofence: (shopId, geoId) => `shop/${shopId}/geofence/${geoId}`,
      viewShopGeofence: (shopId, geoId) => `shop/${shopId}/geofence/${geoId}`,
      editAddress: (shopId, addressId) => `shop/${shopId}/address/${addressId}`,
      deleteAddress: (shopId, addressId) => `shop/${shopId}/address/${addressId}`,
      createAddress: (shopId) => `shop/${shopId}/address`,
      getAllTransaction: (shopId) => `shop/${shopId}/show-transactions-of-rials-wallet`,
      getStatusInquiry: (shopId) => `shop/${shopId}/holiday-status`,
      liteSearch: 'shop/lite/get',
      usersBankAccounts: (shopId) => `shop/${shopId}/users-bank-accounts`,
      bankAccounts: (shopId) => `shop/${shopId}/bank-account`,
      addBankAccount: (shopId) => `shop/${shopId}/bank-account`,
      sendSms: (shopId) => `shop/${shopId}/send-on-demand-sms`,

      reviewed: (shopId) => `shop/${shopId}/comments/change-comments-to-reviewed-by-shop`,
      shopInvioce: (shopId) => `shop/${shopId}/invoice`,
      bestSellingItems: (shopId) => `shop/${shopId}/top-invoiceitems`,
      orderList: (shopId, invoiceId) => `shop/${shopId}/invoice/${invoiceId}`,
      showShopInvoice: (shopId, invoiceId) => `shop/${shopId}/invoice/${invoiceId}`,
      acceptStatus: (shopId, invoiceId) => `shop/${shopId}/invoice/${invoiceId}/accept`,
      shopDiscountCourier: (shopId) => `shop/${shopId}/sync-courier-discount`,
      shopDiscountCourierFee: (shopId) => `shop/${shopId}/sync-courier-km-discount`,

      getShopDiscountCourier: (shopId) => `shop/${shopId}/get-courier-discount`,
      changeStatusGeofance: (shopId, geofenceId) => `shop-settings/${shopId}/geofence/${geofenceId}`,
      changeStatusShop: (shopId) => `shop-settings/${shopId}/change-status`,
      AnnouncingClosureShop: (shopId) => `shop/${shopId}/holiday`,
      isHolidyOpen: (shopId) => `shop/${shopId}/today-open`,
      getOneById: (shopId) => `shop/${shopId}`,
      shopSeacrch: (shopName) => `shop/${shopName}/search`,
      shopWage: (shopId) => `shop/${shopId}/wage`,
      setWage: (shopId) => `shop/${shopId}/wage`,
      shopDiscount: (shopId) => `shop/${shopId}/discount`,
      setDiscountShop: (shopId) => `shop/${shopId}/discount`,
      allShopDiscountCode: (shopId) => `shop/${shopId}/discountcode`,
      deleteDiscountCodeShop: (shopId, discountcodeId) => `shop/${shopId}/discountcode/${discountcodeId}`,
      createDiscountCodeShop: (shopId) => `shop/${shopId}/discountcode`,
      shopEditGeofance: (shopId) => `shop/${shopId}/geofences/batch-update`,
      deleteShopUser: (shopId) => `shop/${shopId}/sync-roles`,
      shopInvioceExcel: (shopId) => `shop/${shopId}/excel-export-invoices`,
      shopBestSellingItemsExcel: (shopId) => `shop/${shopId}/excel-export-top-invoiceitems`,

      sendPanelLinkViaSms: (shopId) => `shop/${shopId}/send-panel-link-via-sms`,
      getCourierSelect: (shopId) => `shop-settings/${shopId}/couriers`,
      syncCouriers: (shopId) => `shop-settings/${shopId}/couriers`,
      delete: (shopId) => `shop/${shopId}`,
      shopProduct: {
        getAll: (shopId) => `shop/${shopId}/product`,
        chefRecommendation: (shopId, productId) => `shop/${shopId}/product/${productId}/chef-recommendation`,
        addProduct: (ShopId) => `shop/${ShopId}/product`,
        create: (ShopId) => `shop/${ShopId}/product`,
        rePrioritizeProducts: (shopId) => `shop/${shopId}/products/re-prioritize`,
        delete: (shopId, productId) => `/shop/${shopId}/product/${productId}`,
        editProduct: (shopId, productId) => `shop/${shopId}/product/${productId}`,
        setDiscount: (shopId, productId) => `shop/${shopId}/product/${productId}/discount`,
        setWage: (shopId, productId) => `shop/${shopId}/product/${productId}/wage`,
        showProduct: (shopId, productId) => `shop/${shopId}/product/${productId}`,
        edit: (shopId, productId) => `shop/${shopId}/product/${productId}`,
        addSaleHours: (shopId, productId) => `shop/${shopId}/product/${productId}/sale-hour`,
        getSaleHours: (shopId, productId) => `shop/${shopId}/product/${productId}/sale-hour`,
        deleteSaleHours: (shopId, productId, saleHoursId) =>
          `shop/${shopId}/product/${productId}/sale-hour/${saleHoursId}`,
        showSaleHours: (shopId, productId, saleHoursId) =>
          `shop/${shopId}/product/${productId}/sale-hour/${saleHoursId}`,
        editSaleHours: (shopId, productId, saleHoursId) =>
          `shop/${shopId}/product/${productId}/sale-hour/${saleHoursId}`,
        getWage: (shopId, productId) => `shop/${shopId}/product/${productId}/wage`,
        getDiscount: (shopId, productId) => `shop/${shopId}/product/${productId}/discount`,
        updateVisibleStatus: (shopId, productId) => `shop/${shopId}/product/${productId}/update-visible-status`,
      },
      shopProductCategory: {
        getAll: (shopId) => `shop/${shopId}/product-category`,
        store: (shopId) => `shop/${shopId}/product-category`,
        edit: (shopId, shopProductCategoryId) => `shop/${shopId}/product-category/${shopProductCategoryId}`,
        rePrioritizeCategories: (shopId) => `shop/${shopId}/product-categories/re-prioritize`,
        getById: (shopProductCategoryId) => `shop/${shopProductCategoryId}/product-category`,
        create: (ShopId, shopProductCategoryId) => `shop/${ShopId}/product-category/${shopProductCategoryId}`,
        delete: (ShopId, shopProductCategoryId) => `shop/${ShopId}/product-category/${shopProductCategoryId}`,
        discount: (shopId, shopProductCategoryId) =>
          `shop/${shopId}/product-category/${shopProductCategoryId}/discount`,
        wage: (shopId, shopProductCategoryId) => `shop/${shopId}/product-category/${shopProductCategoryId}/wage`,
        getDiscount: (shopId, shopProductCategoryId) =>
          `shop/${shopId}/product-category/${shopProductCategoryId}/discount`,
        Show: (shopId, shopProductCategoryId) => `shop/${shopId}/product-category/${shopProductCategoryId}`,
        changeStatus: (shopId, shopProductCategoryId) =>
          `shop/${shopId}/product-category/${shopProductCategoryId}/update-active-status`,
        changeViewStyle: (shopId, shopProductCategoryId) =>
          `shop/${shopId}/product-category/${shopProductCategoryId}/set-view-as-list`,
        getWage: (shopId, shopProductCategoryId) => `shop/${shopId}/product-category/${shopProductCategoryId}/wage`,
        getDiscount: (shopId, shopProductCategoryId) =>
          `shop/${shopId}/product-category/${shopProductCategoryId}/discount`,
        showProductCategory: (shopId, shopProductCategoryId) =>
          `shop/${shopId}/product-category/${shopProductCategoryId}`,
      },
      holidays: {
        create: (shopId) => `shop/${shopId}/holiday`,
        getAll: (shopId) => `shop/${shopId}/holiday`,
        delete: (shopId, holidayId) => `shop/${shopId}/holiday/${holidayId}`,
      },
      users: {
        getAll: (shopId) => `shop/${shopId}/user`,
      },

      shopUserBlock: {
        getAll: (shopId) => `block/shop/${shopId}/user`,
        block: (shopId) => `block/shop/${shopId}/user`,
        unBlockUser: (shopId, userId) => `block/shop/${shopId}/user/${userId}`,
      },

      wage: {
        create: (ShopId) => `shop/${ShopId}/wage`,
      },
      workingHours: {
        getAll: (shopId) => `shop/${shopId}/working-hour`,
        delete: (shopId, workinhHoursId) => `shop/${shopId}/working-hour/${workinhHoursId}`,
        create: (shopId) => `shop/${shopId}/working-hour`,
        edit: (shopId, workinhHoursId) => `shop/${shopId}/working-hour/${workinhHoursId}`,
      },
    },
    priceChange: {
      getByType: (type, subType) => `price?type=${type}&sub_type=${subType}`,
      acceptProductPrice: (id) => `price/${id}`,
      rejectProductPrice: (id) => `price/${id}`,
    },
    courier: {
      getAll: 'courier',
      create: 'courier',
      delete: (courierId) => `courier/${courierId}`,
      getById: (courierId) => `courier/${courierId}`,
      edit: (courierId) => `courier/${courierId}`,
      noticeCallNumbers: (courierId) => `courier/${courierId}/notice-call-numbers`,
      usersCallNumbers: (courierId) => `courier/${courierId}/users-call-numbers`,
      getCheckoutCallNumbers: (courierId) => `courier/${courierId}/checkout-call-numbers`,
      syncNoticeCallNumbers: (courierId) => `courier/${courierId}/notice-call-numbers`,
      syncCheckoutCallNumbers: (courierId) => `courier/${courierId}/checkout-call-numbers`,
      usersBankAccounts: (courierId) => `courier/${courierId}/users-bank-accounts`,
      bankAccounts: (courierId) => `courier/${courierId}/bank-account`,
      addBankAccount: (courierId) => `courier/${courierId}/bank-account`,
      editAddress: (courierId) => `courier/${courierId}/address`,
      getAllTransaction: (courierId) => `courier/${courierId}/show-transactions-of-rials-wallet`,
      getAllInvoice: (courierId) => `courier/${courierId}/invoicecourier`,
      showOneInvoice: (courierId, invoiceId) => `courier/${courierId}/invoicecourier/${invoiceId}`,
      statusShop: (courierId) => `courier/${courierId}/close-or-open-shops-that-has-special-courier`,
      getAllLite: 'courier/lite/get',
      users: {
        getAll: (courierId) => `courier/${courierId}/user`,
      },
    },

    comment: {
      getAll: 'comment',
      getCommentShop: (shopId) => `shop/${shopId}/comment`,
      status: (commentId) => `comment/${commentId}/change-status`,
      sendComment: (commentId) => `comment/${commentId}/reply-support`,
      sendCommentShop: (shopId, commentId) => `shop/${shopId}/comment/${commentId}/reply`,
      edit: (commentId) => `comment/${commentId}`,
      reviewed: 'comments/change-to-reviewed-by-support',
    },

    productStock: {
      getAll: (shopId, productId) => `shop/${shopId}/product/${productId}/stock`,
      delete: (shopId, productId, stockId) => `shop/${shopId}/product/${productId}/stock/${stockId}`,
      create: (shopId, productId) => `shop/${shopId}/product/${productId}/stock`,
      edit: (shopId, productId, stockId) => `shop/${shopId}/product/${productId}/stock/${stockId}`,
      setZeroToday: (shopId, productId) => `shop/${shopId}/product/${productId}/set-zero-today-remaining`,
      increaseTodayRemining: (shopId, productId) => `shop/${shopId}/product/${productId}/increase-today-remaining`,
    },

    requestCoureir: {
      getAll: 'invoicecourier',
      setAsCoordinated: (invoiceId) => `invoice/${invoiceId}/set-as-coordinated`,
    },

    activtiy: {
      getAll: 'activity',
      getOne: (activityId) => `activity/${activityId}`,
      // create: 'advertisement',
      // edit: (advertisementId) => `advertisement/${advertisementId}`,
      // delete: (advertisementId) => `advertisement/${advertisementId}`,
    },
    
    messenger: {
      sendMessage: 'messenger/send-to-long-running-shops',
     
    },
  },
};
